import * as types from '../../mutation-types'
import { certificacaoService } from '../../../services/certificacao/index'
import axios from '@/utils/api'

const state = {
  dadosCertificacao: null,
  loading: false,
  error: null
}

const mutations = {
  [types.SET_DADOS_CERTIFICACAO] (state, dados) {
    state.dadosCertificacao = dados
  },
  [types.SET_LOADING_CERTIFICACAO] (state, loading) {
    state.loading = loading
  },
  [types.SET_ERROR_CERTIFICACAO] (state, error) {
    state.error = error
  }
}

const actions = {
  async salvarCertificacao ({ commit, state }, { dados, despacho }) {
    commit(types.SET_LOADING_CERTIFICACAO, true)
    commit(types.SET_ERROR_CERTIFICACAO, null)
    try {
      await certificacaoService.salvarCertificacao(dados, despacho)

      const dadosSalvos = {
        ...dados,
        dataSalvamento: new Date().toISOString(),
        status: 'SALVO'
      }
      commit(types.SET_DADOS_CERTIFICACAO, dadosSalvos)
      return dadosSalvos
    } catch (error) {
      commit(types.SET_ERROR_CERTIFICACAO, error.message || 'Erro ao salvar certificação')
      throw error
    } finally {
      commit(types.SET_LOADING_CERTIFICACAO, false)
    }
  },

  async finalizarCertificacao ({ commit, state }, { dados, despacho, acao }) {
    commit(types.SET_LOADING_CERTIFICACAO, true)
    commit(types.SET_ERROR_CERTIFICACAO, null)
    try {
      await certificacaoService.finalizarCertificacao(dados, despacho, acao)

      const dadosFinalizados = {
        ...dados,
        status: 'FINALIZADO',
        dataFinalizacao: new Date().toISOString()
      }
      commit(types.SET_DADOS_CERTIFICACAO, dadosFinalizados)
      return dadosFinalizados
    } catch (error) {
      commit(types.SET_ERROR_CERTIFICACAO, error.message || 'Erro ao finalizar certificação')
      throw error
    } finally {
      commit(types.SET_LOADING_CERTIFICACAO, false)
    }
  },

  async finalizarDespacho ({ commit, state }, { acao, despacho }) {
    commit(types.SET_LOADING_CERTIFICACAO, true)
    commit(types.SET_ERROR_CERTIFICACAO, null)
    try {
      const response = await axios({
        url: `certificado/finalizarDespacho`,
        method: 'POST',
        data: {
          acao,
          despacho
        }
      })
      return response
    } catch (error) {
      commit(types.SET_ERROR_CERTIFICACAO, error.message || 'Erro ao finalizar despacho')
      throw error
    } finally {
      commit(types.SET_LOADING_CERTIFICACAO, false)
    }
  },

  async getDocumentoViewByIdProcesso ({ commit, state }, idProcesso) {
    commit(types.SET_LOADING_CERTIFICACAO, true)
    commit(types.SET_ERROR_CERTIFICACAO, null)
    try {
      const response = await axios({
        url: `certificado/documento/view/processo/${idProcesso}`,
        method: 'GET'
      })
      return response
    } catch (error) {
      commit(types.SET_ERROR_CERTIFICACAO, error.message || 'Erro ao buscar documento do certificado')
      throw error
    } finally {
      commit(types.SET_LOADING_CERTIFICACAO, false)
    }
  }
}

const getters = {
  dadosCertificacao: state => state.dadosCertificacao,
  loadingCertificacao: state => state.loading,
  errorCertificacao: state => state.error
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/certificacao/index.js